import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const LOGO = "https://customer-assets.emergentagent.com/job_admissions-roadmap/artifacts/2ac8oce6_Mindways%20logo.png";

export default function TermsOfService() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#fff" }}>
      <header style={{ backgroundColor: "#2B2F9E", padding: "20px 24px" }}>
        <div style={{ maxWidth: "1280px", margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Link to="/">
            <div style={{ backgroundColor: "#fff", borderRadius: "8px", padding: "6px 12px" }}>
              <img src={LOGO} alt="Mindways" style={{ height: "52px", width: "auto", display: "block" }} />
            </div>
          </Link>
          <Link to="/" style={{ color: "rgba(255,255,255,0.85)", fontFamily: "'DM Sans', sans-serif", fontSize: "14px", fontWeight: "600", textDecoration: "none" }}>
            &larr; Back to Home
          </Link>
        </div>
      </header>

      <main style={{ maxWidth: "800px", margin: "0 auto", padding: "64px 24px" }}>
        <span style={{ fontSize: "13px", fontWeight: "700", letterSpacing: "0.12em", textTransform: "uppercase", color: "#F5A000", fontFamily: "'DM Sans', sans-serif" }}>Legal</span>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(28px, 4vw, 42px)", fontWeight: "700", color: "#0F172A", margin: "12px 0 8px", lineHeight: "1.2" }}>Terms of Service</h1>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "14px", color: "#94A3B8", marginBottom: "48px" }}>Last updated: February 2026</p>

        {[
          {
            title: "1. Acceptance of Terms",
            body: "By accessing or using the Mindways website (mindways.in) or submitting any enquiry form, you agree to be bound by these Terms of Service. If you do not agree, please do not use our website or services.",
          },
          {
            title: "2. Services Provided",
            body: "Mindways Consulting Pvt. Ltd. provides overseas education counselling, university shortlisting, application guidance, test preparation strategy, visa guidance, and related advisory services. Our services are advisory in nature. Final decisions on university applications, visa applications, and related matters remain with the student, family, and relevant authorities.",
          },
          {
            title: "3. No Guarantee of Admission",
            body: "Mindways provides guidance and support to maximise your chances of admission. However, we do not guarantee admission to any specific university, programme, or country. Admissions decisions are made solely by universities and are subject to their own criteria.",
          },
          {
            title: "4. Fee-Based Advisory",
            body: "Mindways operates as a fee-based advisory firm. Our fees are disclosed transparently before engagement. We do not receive commissions from universities. All service fees are agreed in writing prior to commencement of paid services.",
          },
          {
            title: "5. Client Responsibilities",
            body: "You agree to provide accurate and complete information when seeking our services. You are responsible for meeting application deadlines, submitting required documents, and complying with university and visa requirements. Mindways accepts no liability for missed deadlines or errors arising from incomplete information provided by the client.",
          },
          {
            title: "6. Intellectual Property",
            body: "All content on this website, including text, graphics, logos, and service materials, is the property of Mindways Consulting Pvt. Ltd. and is protected by applicable intellectual property laws. You may not reproduce, distribute, or use any content without prior written consent.",
          },
          {
            title: "7. Limitation of Liability",
            body: "To the fullest extent permitted by law, Mindways shall not be liable for any indirect, incidental, or consequential damages arising from the use of our website or services. Our total liability in any matter shall not exceed the fees paid by you for the specific service in question.",
          },
          {
            title: "8. Governing Law",
            body: "These Terms are governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts of New Delhi, India.",
          },
          {
            title: "9. Amendments",
            body: "We reserve the right to modify these Terms at any time. Changes will be effective upon posting to this page. Continued use of our website after changes constitutes acceptance of the revised Terms.",
          },
          {
            title: "10. Contact",
            body: "For any queries regarding these Terms, contact us at: study@mindways.in | +91-9821916960 | 1106 Chiranjiv Tower, 43 Nehru Place, New Delhi 110019.",
          },
        ].map((section) => (
          <div key={section.title} style={{ marginBottom: "36px" }}>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "20px", fontWeight: "700", color: "#0F172A", margin: "0 0 12px" }}>{section.title}</h2>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "16px", color: "#475569", lineHeight: "1.75", margin: 0 }}>{section.body}</p>
          </div>
        ))}
      </main>

      <div style={{ backgroundColor: "#2B2F9E", padding: "24px", textAlign: "center" }}>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "13px", color: "rgba(255,255,255,0.6)", margin: 0 }}>
          © {new Date().getFullYear()} Mindways Consulting Pvt. Ltd. · <Link to="/privacy-policy" style={{ color: "rgba(255,255,255,0.6)", textDecoration: "none" }}>Privacy Policy</Link> · <Link to="/cookie-policy" style={{ color: "rgba(255,255,255,0.6)", textDecoration: "none" }}>Cookie Policy</Link>
        </p>
      </div>
    </div>
  );
}
